import Layout from "@/views/Layout"

const permission = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.routers = routers
    },
    SET_ADDROUTERS: (state, addrouters) => {
      state.addRouters = addrouters
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { asyncRouterMap } = data
        //根据asyncRouterMap生成动态路由，主要是把相应的component映射到Layout中的<router-view/>中
        const addRouters = convertRouter(asyncRouterMap)
        console.log("2222")
        console.log(addRouters)
        //生成侧边栏, 这里的routersMenu要传递给el-menu组件生成侧边栏，见components/Common-SideBar.vue
        const routersMenu = getRouterMenu(asyncRouterMap)
        console.log("3333")
        console.log(routersMenu)
        commit("SET_ADDROUTERS", addRouters)
        //生成侧边栏
        commit("SET_ROUTERS", routersMenu)
        resolve()
      })
    }
  }
}

export default permission

/**
 * 将后台的路由表进行格式化为前端vue可以使用的格式,主要用来添加路由
 * @param {*} asyncRouterMap
 */
function convertRouter(asyncRouterMap) {
  const vueRouters = [
    {
      path: "",
      //component: () => import("@/views/Layout"),
      component: Layout,
      children: []
    }
  ]
  //const vueRouters = []
  if (asyncRouterMap) {
    asyncRouterMap.forEach(item => {
      if (item.children.length > 0) {
        item.children.forEach(child => {
          vueRouters[0].children.push(generateRouter(child))
        })
        vueRouters[0].children.push(generateRouter(item))
      } else {
        item.children = []
        vueRouters[0].children.push(generateRouter(item))
      }
    })
  }
  //这里把404的vue放到vueRouters外边，不作为Layout的router-view显示,后台根据角色动态返回路由
  vueRouters.push({ path: "*", name: "404", component: () => import(`@/views/ErrorPage/404.vue`) })
  //console.log(vueRouters)
  return vueRouters
}
/**
 * 主要用来添加侧边树形菜单,由于我整个项目组织到Layout.vue中了，结合我的sidebaritem组件[嵌套实现], 因此这里要和addRouter区别开来
 * @param {*} asyncRouterMap
 */
function getRouterMenu(asyncRouterMap) {
  const vueRouterMenus = []
  if (asyncRouterMap) {
    asyncRouterMap.forEach(item => {
      var parent = generateRouter(item)
      var children = []
      if (item.children.length > 0) {
        item.children.forEach(child => {
          children.push(generateRouter(child))
        })
      }
      parent.children = children
      vueRouterMenus.push(parent)
    })
  }
  return vueRouterMenus
}

/**
 * 生成vue配置类的routers
 * @param item array
 * @param isParent boolean
 */
function generateRouter(item) {
  var router = {
    path: item.path,
    name: item.name,
    meta: item.meta,
    component: item.component === "Layout" ? Layout : () => import(`@/views/${item.component}.vue`),
    redirect: item.redirect ? item.redirect : item.component === "Layout" ? "noredirect" : ""
    //alwaysShow: item.children.length === 1
  }
  return router
}
